import React from 'react';
import PropTypes from 'prop-types';
import { StyledItem, ItemText, StyledBadge } from './Styles';

const Item = ({ onClick, icon, text, badge }) => {
  return (
    <StyledItem onClick={onClick} badge={badge}>
      <i className={`fa ${icon}`} aria-hidden="true">
        {(badge || badge === 0) && <StyledBadge>{badge}</StyledBadge>}
      </i>
      <ItemText>{text}</ItemText>
    </StyledItem>
  );
};

Item.defaultProps = {
  text: 'Need Text',
  icon: '',
  badge: null,
};

Item.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  badge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Item;
